<script setup lang="ts">
import { Check } from 'lucide-vue-next'
import { computed } from 'vue'

const props = defineProps({
    label: String,
    modelValue: [String, Number, Date],
    type: {
        type: String,
        default: 'text',
    },
    error: {
        type: String,
        default: '',
    },
    success: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    max: {
        type: String,
        default: null,
    },
    min: {
        type: String,
        default: null,
    },
})

defineEmits(['update:modelValue'])

const inputId = `input-${Math.random().toString(36).slice(2, 9)}`

const inputClasses = computed(() => {
    if (props.error) return 'border-primary focus:border-primary'
    if (props.success) return 'border-green-500 focus:border-green-500'
    return 'border-gray-300 focus:border-primary'
})
</script>


<template>
  <div class="relative">
    <input
        :id="inputId"
        :type="type"
        :value="modelValue"
        :disabled="disabled"
        :readonly="readonly"
        :max="max"
        :min="min"
        @input="$emit('update:modelValue', $event.target.value)"
        placeholder=" "
        class="peer h-12 w-full rounded-md bg-white px-4 pt-5 text-sm
             transition focus:outline-none

             border
             disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed
             readonly:bg-gray-50"
        :class="inputClasses"
    />

    <!-- Label (klikbaar) -->
    <label
        :for="inputId"
        class="pointer-events-auto absolute left-4 transition-all
             top-3.5 cursor-text text-sm text-gray-500

             peer-focus:top-1 peer-focus:text-xs peer-focus:text-primary
             peer-not-placeholder-shown:top-1 peer-not-placeholder-shown:text-xs"
    >
      {{ label }}
    </label>

    <!-- Success icon -->
    <Check
        v-if="success"
        :class="{
            'right-12': type === 'date' || type === 'number',
        }"
        class="absolute right-4 top-1/2 h-5 w-5 -translate-y-1/2 text-green-500"
    />

    <!-- Error message -->
    <p v-if="error" class="mt-1 text-xs text-primary">
      {{ error }}
    </p>
  </div>
</template>
